
if (!customElements.get('ks-announcement-bar')) {
  class KsAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.ks-announcement-slide'));
      this.prevBtn = this.querySelector('.ks-nav-prev');
      this.nextBtn = this.querySelector('.ks-nav-next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (Number.parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.currentIndex = 0;
      this.timer = null;
      this.changeSlide = this.changeSlide.bind(this);
      this.stopAutoplay = this.stopAutoplay.bind(this);
      this.startAutoplay = this.startAutoplay.bind(this);
    }
    connectedCallback() {
      if (this.slides.length < 2) return;
      this.prevBtn?.addEventListener('click', () => this.changeSlide(-1));
      this.nextBtn?.addEventListener('click', () => this.changeSlide(1));
      this.addEventListener('mouseenter', this.stopAutoplay);
      this.addEventListener('mouseleave', this.startAutoplay);
      this.startAutoplay();
    }
    disconnectedCallback() {
      this.stopAutoplay();
      this.removeEventListener('mouseenter', this.stopAutoplay);
      this.removeEventListener('mouseleave', this.startAutoplay);
    }
    changeSlide(direction) {
      this.slides[this.currentIndex]?.classList.remove('active');
      this.currentIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;
      this.slides[this.currentIndex]?.classList.add('active');
      this.restartAutoplay();
    }
    startAutoplay() {
      if (!this.autoplay || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.changeSlide(1), this.speed);
    }
    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
  customElements.define('ks-announcement-bar', KsAnnouncementBar);
}

